// import httpService, { getUserId } from "./httpService";
import httpService from "./httpService";
import { getBaseUrl } from "../helpers/baseUrlHelper";

const hasCorrectionPrivilege = async => {
	//Make API call here (intract with server component and get the actual response)
	const baseUrl = getBaseUrl();

	return httpService
		.get(baseUrl + "hasPrivilege", {
			useAuth: true
		})
		.then(response => {
			//console.log(response);
			return response;
		})
		.catch(error => {
			console.log(error);
			return Promise.reject({ hasPrivilege: false, reason: error.message });
		});
};

export { hasCorrectionPrivilege };
